export default {
    Metadata: {
        Name: "Round",
        Description: "Returns a decimal rounded to the nearest integer.",
        Syntax: "Round(value)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(value, Precision) {  //Overload
        return Math.round(value);
    },
};

